<div class="message-input-container h-75" [formGroup]="messageForm">
  <div class="row">
    <div class="col-lg-2 col-md-4 col-sm-12">
      <select id="messageType" formControlName="messageType">
        <option value="Text">Text</option>
        <option value="ImageTemplate">Image Template</option>
        <option value="Template">Template</option>
      </select>
    </div>

    <div class="col-lg-9 col-md-4 col-sm-12">
      <div *ngIf="messageForm.get('messageType').value === 'Text'" class="input-section">
        <textarea formControlName="textMessage" placeholder="Enter your message..." rows="4"></textarea>
      </div>

      <div *ngIf="messageForm.get('messageType').value === 'ImageTemplate'" class="input-section">
        <input formControlName="templateName" placeholder="Enter template name..." type="text" />
        <input formControlName="imageUrl" placeholder="Enter image URL..." type="text" />
      </div>

      <div *ngIf="messageForm.get('messageType').value === 'Template'" class="input-section">
        <input formControlName="templateName" placeholder="Enter template name..." type="text" />
      </div>
    </div>

    <div class="col-lg-1 col-md-4 col-sm-12">
      <button (click)="onSendMessage()">Send</button>
    </div>
  </div>
</div>